// Static-friendly API layer.
// In production (seohost.pl) the frontend talks ONLY to /contact.php — no Node/Python backend.
// During Emergent preview we keep the FastAPI fallback so the form still works here.

import axios from "axios";
import { ARTWORKS } from "../data/artworks";

const EMERGENT_BACKEND = process.env.REACT_APP_BACKEND_URL;
// On a static deploy this env var won't be set -> we use a relative PHP endpoint.
const IS_STATIC = !EMERGENT_BACKEND;

const CONTACT_ENDPOINT = IS_STATIC
  ? "/contact.php"
  : `${EMERGENT_BACKEND}/api/contact`;

export async function fetchArtworks() {
  // Always return static data — no backend roundtrip needed.
  return ARTWORKS;
}

export async function sendContact(payload) {
  const { data } = await axios.post(CONTACT_ENDPOINT, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data;
}
